/**
 * Marketing: codes the travel permissions query now returns next to the Travel: ones (the
 * backend unions the marketing module's grants in). Any of these lets the editor open the
 * workspace asset library.
 */
export const MarketingAssetPermissions = {
  ALL: "Marketing:*",
  ASSETS: "Marketing:Assets:*",
  CAMPAIGNS: "Marketing:Campaigns:*",
  LANDING_PAGES: "Marketing:Campaigns:LandingPages:*",
  EMAIL_TEMPLATES: "Marketing:Campaigns:EmailTemplates:*",
} as const;

export type MarketingAssetPermission =
  (typeof MarketingAssetPermissions)[keyof typeof MarketingAssetPermissions];

export const MARKETING_ASSET_BROWSE_PERMISSIONS = [
  MarketingAssetPermissions.ASSETS,
  MarketingAssetPermissions.CAMPAIGNS,
  MarketingAssetPermissions.LANDING_PAGES,
  MarketingAssetPermissions.EMAIL_TEMPLATES,
];
